import { gql } from '@apollo/client'

export const createClientFund = gql`
  mutation CreateClientFund($input: CreateClientFundInput!) {
    createClientFund(input: $input) {
      id
      fundId
      token
      status
      statusLabel
      clientEmail
      clientFirstName
      clientLastName
      corporateName
      fundType
      expiresAt
    }
  }
`

export const claimFundNewUser = gql`
  mutation ClaimFundNewUser($input: ClaimFundNewUserInput!) {
    claimFundNewUser(input: $input) {
      id
      email
    }
  }
`

export const claimFundExistingUser = gql`
  mutation ClaimFundExistingUser($token: String!, $acceptTerms: Boolean, $termsVersion: String) {
    claimFundExistingUser(token: $token, acceptTerms: $acceptTerms, termsVersion: $termsVersion) {
      id
      name
      number
    }
  }
`

export const acceptSecondaryFundClaimInvite = gql`
  mutation AcceptSecondaryFundClaimInvite($token: String!) {
    acceptSecondaryFundClaimInvite(token: $token)
  }
`

export const declineFundClaimInvite = gql`
  mutation DeclineFundClaimInvite($token: String!) {
    declineFundClaimInvite(token: $token)
  }
`

export const resendFundClaimEmail = gql`
  mutation ResendFundClaimEmail($fundClaimInviteId: Int!) {
    resendFundClaimEmail(fundClaimInviteId: $fundClaimInviteId)
  }
`

export const resendAdvisorFundClaimEmail = gql`
  mutation ResendAdvisorFundClaimEmail($fundClaimInviteId: Int!) {
    resendAdvisorFundClaimEmail(fundClaimInviteId: $fundClaimInviteId)
  }
`

export const cancelAdvisorFundClaimInvite = gql`
  mutation CancelAdvisorFundClaimInvite($fundClaimInviteId: Int!) {
    cancelAdvisorFundClaimInvite(fundClaimInviteId: $fundClaimInviteId)
  }
`

export const reissueAdvisorFundClaimEmail = gql`
  mutation ReissueAdvisorFundClaimEmail($fundClaimInviteId: Int!) {
    reissueAdvisorFundClaimEmail(fundClaimInviteId: $fundClaimInviteId)
  }
`

export const advisorReinviteDonor = gql`
  mutation AdvisorReinviteDonor($onboardingFlowId: Int!) {
    advisorReinviteDonor(onboardingFlowId: $onboardingFlowId) {
      id
      fundId
    }
  }
`
